<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="exportAllNotificationCard"
  [notificationIcon]="'svg_excel'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadSpreadsheetButtonClickedEvent)="downloadAllButtonClickedHandler()"
      [downloadSpreadsheetFlag]="true"
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
